/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchDto } from './BranchDto';
import {
    BranchDtoFromJSON,
    BranchDtoFromJSONTyped,
    BranchDtoToJSON,
    BranchDtoToJSONTyped,
} from './BranchDto';

/**
 * 
 * @export
 * @interface ProviderDto
 */
export interface ProviderDto {
    /**
     * Provider ID (Firebase UID)
     * @type {string}
     * @memberof ProviderDto
     */
    id: string;
    /**
     * Provider first name
     * @type {string}
     * @memberof ProviderDto
     */
    firstName: string;
    /**
     * Provider last name
     * @type {string}
     * @memberof ProviderDto
     */
    lastName: string;
    /**
     * Provider middle name
     * @type {string}
     * @memberof ProviderDto
     */
    displayName: string;
    /**
     * Provider email
     * @type {string}
     * @memberof ProviderDto
     */
    email: string;
    /**
     * Provider phone number
     * @type {string}
     * @memberof ProviderDto
     */
    phoneNumber: string;
    /**
     * Provider NPI
     * @type {string}
     * @memberof ProviderDto
     */
    npi: string;
    /**
     * Provider specialties
     * @type {string}
     * @memberof ProviderDto
     */
    specialty: string;
    /**
     * Provider branch
     * @type {BranchDto}
     * @memberof ProviderDto
     */
    branch: BranchDto;
    /**
     * Provider status
     * @type {string}
     * @memberof ProviderDto
     */
    status: string;
    /**
     * Provider avatar URL
     * @type {string}
     * @memberof ProviderDto
     */
    avatarUrl: string;
    /**
     * Provider's practice name
     * @type {string}
     * @memberof ProviderDto
     */
    practiceName: string;
}

/**
 * Check if a given object implements the ProviderDto interface.
 */
export function instanceOfProviderDto(value: object): value is ProviderDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    if (!('specialty' in value) || value['specialty'] === undefined) return false;
    if (!('branch' in value) || value['branch'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('practiceName' in value) || value['practiceName'] === undefined) return false;
    return true;
}

export function ProviderDtoFromJSON(json: any): ProviderDto {
    return ProviderDtoFromJSONTyped(json, false);
}

export function ProviderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'displayName': json['displayName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'npi': json['npi'],
        'specialty': json['specialty'],
        'branch': BranchDtoFromJSON(json['branch']),
        'status': json['status'],
        'avatarUrl': json['avatarUrl'],
        'practiceName': json['practiceName'],
    };
}

export function ProviderDtoToJSON(json: any): ProviderDto {
    return ProviderDtoToJSONTyped(json, false);
}

export function ProviderDtoToJSONTyped(value?: ProviderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'displayName': value['displayName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'npi': value['npi'],
        'specialty': value['specialty'],
        'branch': BranchDtoToJSON(value['branch']),
        'status': value['status'],
        'avatarUrl': value['avatarUrl'],
        'practiceName': value['practiceName'],
    };
}

